import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import styled from "styled-components";
import Ellipse12 from "../assets/IconLibrary/Ellipse12.svg";
import user2 from "../assets/IconLibrary/user(2).svg";
import forms from "../data/rushdata.json";

// import Forms from "../../data"
const MultiFrom = () => {
  const [value, setValue] = useState();
  const [activeform] = useState(forms.formOne);
  const [activeformTwo] = useState(forms.formTwo);
  const [active, setActive] = useState(2);
  const [activeTwo, setActiveTwo] = useState(0);
  const onClickFunction = (id) => {
    setActive(id);
  };
  const onClickFunctionTwo = (id) => {
    setActiveTwo(id);
  };

  const [users, setUsers] = useState(1);
  const [form, setForm] = useState(1);
  return (
    <Wrapper>
      <div className="pill__Wrapper">
        <div className="rush__pill__Line">
          <div className="line__Namber__Wrapper">
            <div className="line__Namber">
              <span
                className={
                  form === 2
                    ? "line__Namber__count"
                    : "line__Namber__count active"
                }
              >
                1
              </span>
              <small
                className={
                  form === 2
                    ? "line__Namber__Text"
                    : "line__Namber__Text active"
                }
              >
                Choose Location
              </small>
            </div>
            <div className="line__Namber">
              <span
                className={
                  form === 1
                    ? "line__Namber__count"
                    : "line__Namber__count active"
                }
              >
                2
              </span>
              <small
                className={
                  form === 1
                    ? "line__Namber__Text"
                    : "line__Namber__Text active"
                }
              >
                Provide Information
              </small>
            </div>
          </div>
          <div className="line"></div>
        </div>

        {form === 1 ? (
          <div className="from_wrpper">
            <h1 className="form_header_text">Choose your location</h1>
            <p className="chul form_subheader_text">
              Select pickup and dropoff locations
            </p>
            <form action="email" className="from">
              <label className="Phone_header_text">Select your city</label>
              <div className="select_city mt-2 finput">
                <select className="select_city_option">
                  <option value="volvo">Dhaka</option>
                  <option value="saab">Khulna</option>
                  <option value="mercedes">Madaripur</option>
                  <option value="audi">Borishal</option>
                </select>
                {/* <img className="arrow" src={arrow} alt="img" /> */}
              </div>
              <label className="Phone_header_text">Pickup Location</label>
              <input
                className="mt-2 finput"
                type="text"
                placeholder="Indianapolis Motor Speedway, 4790 W 16th St"
              />
              <label className="Phone_header_text">Drop-off Location</label>
              <input
                className="mt-2 finput"
                type="text"
                placeholder="4000 N Michigan Rd, Indianapolis"
              />
            </form>
          </div>
        ) : undefined}

        {form === 2 ? (
          <div className="from_wrpper">
            <h1 className="form_header_text">Provide Information</h1>
            <p className="form_subheader_text">
              Provide more information about this order.
            </p>
            <div className="select_a_vehicle">
              <p className="select_header_text">select a vehicle</p>
              <div className="select_a_vehicle_btn_grop">
                {activeform.map((element, index) => (
                  <div
                    className={
                      active === index
                        ? "select_a_vehicle_btn activebtn"
                        : "select_a_vehicle_btn"
                    }
                    key={element.id}
                    onClick={() => onClickFunction(index)}
                  >
                    <span>{element.Name}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="service_Type">
              <p className="service_header_text">Service Type</p>
              <div className="service_Type_grop">
                {activeformTwo.map((element, index) => (
                  <div
                    className={
                      activeTwo === index
                        ? "service_Type_btn activebtn"
                        : "service_Type_btn"
                    }
                    key={element.id}
                    onClick={() => onClickFunctionTwo(index)}
                  >
                    <span>{element.Name}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="pickup_Details">
              <h4 className="pickup_header_text">Pickup Details</h4>
              <label className="puckup Phone_header_text">
                Who’s the package being picked up for?{" "}
                <span className="start">*</span>
              </label>
              <div className="user_acc">
                <div
                  onClick={() => setUsers(1)}
                  className={`user_card ${
                    users === 1 ? "activebtn" : undefined
                  }`}
                >
                  <img src={Ellipse12} alt="img" />
                  <span>Others</span>
                </div>

                <div
                  onClick={() => setUsers(2)}
                  className={`user_card ${
                    users === 2 ? "activebtn" : undefined
                  }`}
                >
                  <img src={user2} alt="img" />
                  <span>Myself</span>
                </div>
              </div>
            </div>

            {users === 1 ? (
              <form action="email" className="from">
                <label className="Phone_header_text">
                  Pickup Location Phone<span className="start">*</span>
                </label>
                <div className="select_city">
                  <PhoneInput
                    international
                    defaultCountry="US"
                    value={value}
                    onChange={setValue}
                  />
                </div>
                <label className="Phone_header_text">
                  Item Quantity<span className="start">*</span>
                </label>
                <p className="Phone_subheader_text">
                  Ensure you have someone available to assist for items over
                  50lbs
                </p>
                <input type="text" />
                <label className="ref_Number_header_text">
                  Ref Number or PO Number{" "}
                  <span className="opshonal">- optional</span>
                </label>
                <p className="ref_Number_subheader_text">
                  This is a reference number or name for your record keeping{" "}
                </p>
                <input type="text" />
                <label className="Instructions_header_text">
                  Pickup Instructions
                  <span className="opshonal">- optional</span>
                </label>
                <p className="Instructions_subheader_text">
                  Please provide clear instructions on where to go, who to meet,
                  what to do.
                </p>
                <textarea placeholder="" rows="4" cols="50"></textarea>
              </form>
            ) : undefined}

            {users === 2 ? (
              <form action="email" className="from">
                <label className="Phone_header_text">
                  Enter the name of the individual or company
                  <span className="start">*</span>
                </label>
                {/* <p className="Phone_subheader_text">
                Ensure you have someone available to assist for items over 50lbs
              </p> */}
                <input className="mt-2" type="text" />
                <label className="Phone_header_text">
                  Pickup Location Phone<span className="start">*</span>
                </label>
                <div className="select_city mt-2">
                  <PhoneInput
                    international
                    defaultCountry="US"
                    value={value}
                    onChange={setValue}
                  />
                </div>
                <label className="Phone_header_text">
                  Email Address (es) For Updates<span className="start">*</span>
                </label>
                {/* <p className="Phone_subheader_text">
                Ensure you have someone available to assist for items over 50lbs
              </p> */}
                <input className="mt-2" type="text" />
                <label className="ref_Number_header_text">
                  Phone Number (s) For Updates<span className="start">*</span>
                </label>
                {/* <p className="ref_Number_subheader_text">
                This is a reference number or name for your record keeping{" "}
              </p> */}
                <input className="mt-2" type="text" />
                <label className="Instructions_header_text">
                  Delivery Instructions - optional
                  <span className="opshonal">- optional</span>
                </label>
                {/* <p className="Instructions_subheader_text">
                Please provide clear instructions on where to go, who to meet,
                what to do.
              </p> */}
                <textarea
                  className="mt-2"
                  placeholder=""
                  rows="4"
                  cols="50"
                ></textarea>
              </form>
            ) : undefined}
          </div>
        ) : undefined}

        <div className="rush__Pill__Btn">
          <button onClick={() => setForm(1)} className="Pill__Btn__f">
            Back
          </button>
          <button onClick={() => setForm(2)} className="Pill__Btn__l">
            Next
          </button>
        </div>
      </div>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  @media screen and (max-width: 440px) {
    .pill__Wrapper {
      width: 100% !important;
      margin: auto;
      padding: 10px;
    }
    .select_a_vehicle_btn {
      margin: 0 0 10px 0;
    }
    .line {
      width: 63% !important;
    }
  }
  p.chul.form_subheader_text {
    margin: 0px !important;
  }
  label.puckup.Phone_header_text.puckup {
    padding-top: 0px !important;
  }
  span.start {
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    color: #d80027;
    padding-left: 12px;
  }
  span.opshonal {
    font-size: 8px;
    margin-left: 8px;
    /* font-family: 'Nunito Sans'; */
    font-style: italic !important;
  }
  .activebtn {
    border: 2px solid #6300ff !important;
  }
  margin: 50px 0;

  .pill__Wrapper {
    width: 530px;
    margin: auto;
  }
  .line {
    width: 74%;
    height: 2px;
    background: rgba(38, 50, 56, 0.12);
    margin: auto;
    transform: translate(0px, -32px);
  }

  .rush__pill__Line {
    padding: 20px 0;
  }

  .line__Namber__Wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 999;
  }
  h1.form_header_text {
    font-family: Gilroy;
    font-style: normal;
    font-weight: 800;
    font-size: 30px;
    line-height: 37px;
    /* identical to box height */
    display: flex;
    align-items: center;
    color: #6300ff;
  }
  .line__Namber {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  span.line__Namber__count.active {
    background: #6300ff;
  }
  span.line__Namber__count {
    font-family: Gilroy-Bold;
    font-size: 16px;
    line-height: 18px;
    /* identical to box height, or 112% */
    text-align: center;
    color: #ffffff;
    background: #cfd8dc;
    padding: 3px 8px;
    border-radius: 91%;
    z-index: 999;
  }
  small.line__Namber__Text.active {
    font-family: Gilroy-Bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    opacity: 1;
    color: #455a64;
  }
  small.line__Namber__Text {
    font-family: Gilroy-Bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #455a64;
    opacity: 0.2;
  }

  input.PhoneInputInput {
    outline: none;
    border: none;
  }
  .select_a_vehicle {
    .select_a_vehicle_btn_grop {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .select_a_vehicle_btn {
        font-family: Manrope;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 19px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #545777;
        background: #ffffff;
        border-radius: 5px;
        padding: 15px 29px;
        border: none;
        outline: none;
        box-shadow: 0px 2px 20px 0px #2b1c4214;
        cursor: pointer;
        border: 2px solid transparent;
      }
    }
  }
  .service_Type {
    .service_Type_grop {
      display: flex;
      .service_Type_btn {
        font-family: Manrope;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 19px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #545777;
        background: #ffffff;
        border-radius: 5px;
        padding: 15px 29px;
        border: none;
        outline: none;
        margin: 0 28px 0 0;
        box-shadow: 0px 2px 20px 0px #2b1c4214;
        cursor: pointer;
        border: 2px solid transparent;
      }
    }
  }
  .pickup_Details {
    h4 {
      font-family: Manrope;
      font-style: normal;
      font-weight: 800;
      font-size: 16px;
      line-height: 22px;
      /* identical to box height */
      color: #000000;
    }
    .user_acc {
      display: flex;
      margin-top: 19px;
      .user_card {
        width: 100px;
        height: 80px;
        box-shadow: 2px 2px 20px 0px;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        padding: 15px 13px;
        align-items: baseline;
        margin: 0 10px 0 0;
        box-shadow: 0px 2px 20px 0px #2b1c4214;
        cursor: pointer;
        border: 2px solid transparent;
      }
    }
  }

  /*from wrappper */
  .from_wrpper {
    margin-top: 100px;

    p.form_subheader_text {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      /* identical to box height */
      display: flex;
      align-items: center;
      color: #96a0a8;
    }

    p.select_header_text {
      font-family: Manrope;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #96a0a8;
    }

    p.form_subheader_text {
      margin-bottom: 70px;
    }

    .service_Type {
      margin-top: 50px;
      margin-bottom: 90px;
    }

    label.Instructions_header_text,
    label.ref_Number_header_text,
    label.Phone_header_text {
      font-family: Manrope;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      line-height: 16px;
      color: #a5a3b4;
      padding: 48px 0 3px 0 !important;
      margin: 0;
      letter-spacing: 1px;
    }
    p.Instructions_subheader_text,
    p.ref_Number_subheader_text,
    p.Phone_subheader_text {
      font-family: Manrope;
      font-style: normal;
      font-weight: bold;
      font-size: 8px;
      line-height: 11px;
      color: #dadada;
      margin: 0 0 10px 0;
    }

    form.from {
      display: flex;
      /* align-items: center; */
      flex-direction: column;
      width: 100%;
      text-align: left;
      justify-content: flex-end;
      .select_city {
        width: 100%;
        padding: 13px 22px;
        border: 2px solid #cfdadd;
        border-radius: 5px;
      }
      select.select_city_option {
        width: 100%;
        border: none;
        font-family: Manrope;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: #8a8b99;
        outline: none;
      }
      input[type="text"] {
        color: #8a8b99;
        padding: 12px;
        border: 2px solid #cfdadd;
        border-radius: 5px;
        outline: none;
        font-family: Manrope;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        align-items: center;
      }
      textarea {
        background: #ffffff;
        border: 1.5px solid #dbe0eb;
        box-sizing: border-box;
        border-radius: 4px;
        outline: none;
        border: 2px solid #cfdadd;
      }
    }
  }

  /*from wrappper */
  button.Pill__Btn__l {
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    /* identical to box height */
    /* display: flex; */
    align-items: center;
    text-align: center;
    color: #ffffff;
    background: #6300ff;
    border-radius: 5px;
    width: 201px;
    height: 50px;
    border: 2px solid #6300ff;
    outline: none;
    margin: 0 12px 0 0;
  }
  button.Pill__Btn__f {
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #6300ff;
    border-radius: 5px;
    background-color: transparent;
    width: 201px;
    height: 50px;
    border: 2px solid #6300ff;
    outline: none;
    margin: 0 12px 0 0;
  }
  .rush__Pill__Btn {
    display: flex;
    margin: 129px 0 0 0;
  }
`;
export default MultiFrom;
